import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../Header/Navbar';
import Footer from '../Footer/Footer';
import BackToTop from '../BackToTop/BackToTop';
import Topbar from '../Header/Topbar';
import ProductGrid from './ProductGrid';
import Pagination from './Pagination';
import SEO from '../SEO/SEO';
import './Products.css';

const AmaronProducts = () => {
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

  const amaronCategories = [
    { id: 'car-batteries', name: 'Car Batteries', brand: 'amaron' },
    { id: 'pro-rider', name: 'Pro Rider Batteries', brand: 'amaron' },
    { id: 'inverter-batteries', name: 'Inverter Batteries', brand: 'amaron' },
    { id: 'tubular-batteries', name: 'Tubular Batteries', brand: 'amaron' },
    { id: 'solar-combos', name: 'Solar Combos', brand: 'amaron' }
  ];

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const clearSearch = () => {
    setSearchQuery('');
    setCurrentPage(1);
  };

  const getTotalProducts = () => {
    const productCounts = {
      'car-batteries': 7,
      'pro-rider': 8,
      'inverter-batteries': 6,
      'tubular-batteries': 2,
      'solar-combos': 4
    };
    
    return Object.values(productCounts).reduce((sum, count) => sum + count, 0);
  };

  return (
    <>
      <SEO 
        title="Amaron Batteries"
        description="Shop for maintenance-free Amaron batteries at Galaxy Power System, Chidambaram. High-performance batteries for cars, bikes, and inverters."
        keywords="amaron battery dealer, amaron car battery chidambaram, amaron bike battery, amaron maintenance free"
        canonicalUrl="https://galaxypowersystems.com/amaron-products"
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'Amaron Products', url: '/amaron-products' }
        ]}
      />
      <Topbar />
      <Navbar />
      <div className="container-fluid product py-5" id="products">
        <div className="container py-5">
          <div className="row mb-5">
            <div className="col-12 text-center">
              <h1 className="display-5 mb-3" style={{ color: '#0066CC' }}>
                <i className="fas fa-car-battery me-2"></i> Amaron Batteries
              </h1>
              <p className="lead text-muted mb-4">
                Amaron Batteries is known for its maintenance-free batteries with advanced technology. 
                They offer reliable power solutions for automotive and inverter applications.
              </p>
            </div>
          </div>

          <div className="row g-4 align-items-center mb-5">
            <div className="col-lg-4 col-md-12">
              <h3 className="mb-0">All Amaron Products</h3>
            </div>
            
            <div className="col-lg-5 col-md-8">
              <div className="position-relative">
                <div className="d-flex border rounded-pill" style={{ backgroundColor: '#fff', borderColor: '#ddd' }}>
                  <input 
                    className="form-control border-0 rounded-pill w-100 py-2" 
                    type="text"
                    placeholder="Search Amaron products..."
                    value={searchQuery}
                    onChange={handleSearch}
                    style={{ fontSize: '14px' }}
                  />
                  {searchQuery && (
                    <button 
                      type="button" 
                      className="btn btn-link text-primary"
                      onClick={clearSearch}
                      style={{ border: '0', fontSize: '14px' }}
                    >
                      <i className="fas fa-times"></i>
                    </button>
                  )}
                </div>
              </div>
            </div>
            
            <div className="col-lg-3 col-md-4 text-end">
              <div className="badge bg-primary rounded-pill py-2 px-4">
                Total Products: {getTotalProducts()}
              </div>
            </div>
          </div>
          
          <div className="tab-content">
            <ProductGrid 
              categories={amaronCategories} 
              currentPage={currentPage} 
              brand="amaron"
              searchQuery={searchQuery}
            />
            
            {/* Pagination */}
            {!searchQuery && (
              <Pagination 
                totalPages={amaronCategories.length}
                currentPage={currentPage}
                onPageChange={setCurrentPage}
                paginationId="amaron-pagination"
              />
            )}
          </div>
        </div>
      </div>
      <BackToTop />
      <Footer />
    </>
  );
};

export default AmaronProducts;